var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"left-screen"},[_c('router-view',{attrs:{"name":"left"}})],1),_c('div',{staticClass:"right-screen"},[_c('router-view',{attrs:{"name":"right"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }